"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChromeTooltipBox = exports.InnerMaxHeight = exports.InnerMaxWidth = exports.OuterMaxHeight = exports.OuterMaxWidth = exports.BorderWidth = exports.Padding = void 0;
var React = require("react");
var widgets_1 = require("@tableau/widgets");
exports.Padding = 8;
exports.BorderWidth = widgets_1.TabStyles.Sizing.BorderWidth;
exports.OuterMaxWidth = 250;
exports.OuterMaxHeight = 250;
exports.InnerMaxWidth = exports.OuterMaxWidth - 2 * (exports.Padding + exports.BorderWidth);
exports.InnerMaxHeight = exports.OuterMaxHeight - 2 * (exports.Padding + exports.BorderWidth);
var OuterStyle = {
    flexGrow: 0,
    padding: exports.Padding,
    borderWidth: exports.BorderWidth,
    borderStyle: 'solid',
    borderColor: widgets_1.TabStyles.Colors.L5,
    borderRadius: widgets_1.TabStyles.Sizing.BorderRadius,
    boxShadow: widgets_1.TabStyles.Shadow.Standard,
    backgroundColor: widgets_1.TabStyles.Colors.White,
};
// NOTE inner div handles content overflow so that scroll bars appear within padding of outer div
var InnerStyle = {
    maxWidth: exports.InnerMaxWidth,
    maxHeight: exports.InnerMaxHeight,
    overflowY: 'auto'
};
function ChromeTooltipBox(props) {
    return (React.createElement("div", { style: OuterStyle },
        React.createElement("div", { style: getInnerStyle(props.width) }, props.content)));
}
exports.ChromeTooltipBox = ChromeTooltipBox;
function getInnerStyle(width) {
    return __assign(__assign({}, InnerStyle), { width: width });
}
//# sourceMappingURL=ChromeTooltipBox.js.map